import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'hoodies',
  templateUrl: './hoodies.component.html',
  styleUrls: ['./hoodies.component.css']
})
export class HoodiesComponent implements OnInit {

  constructor() {
  }
  ngOnInit() {
  } 
}

